// @core/api/endpoints/resource/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateExternalResource } from './create_external_resource';
import { GetExternalResourceByURL } from './get_external_resource_by_url';
import { GetLinkStats } from './get_link_stats';
import { GetResourceType } from './get_resource_type';
import { LinkResources } from './link_resources';
import { ListExternalResources } from './list_external_resources';
import { ListLinks } from './list_links';
import { ListRecentResources } from './list_recent_resources';
import { ListResourceTypes } from './list_resource_types';
import { RefreshExternalResource } from './refresh_external_resource';
import { ResolveURNs } from './resolve_ur_ns';
import { SearchResources } from './search_resources';
import { UnlinkResources } from './unlink_resources';
import { UpdateResourceLink } from './update_resource_link';

// Re-export individual endpoints
export {
  CreateExternalResource,
  GetExternalResourceByURL,
  GetLinkStats,
  GetResourceType,
  LinkResources,
  ListExternalResources,
  ListLinks,
  ListRecentResources,
  ListResourceTypes,
  RefreshExternalResource,
  ResolveURNs,
  SearchResources,
  UnlinkResources,
  UpdateResourceLink,
};

// Namespace export for convenient usage
export const resourceApi = {
  CreateExternalResource,
  GetExternalResourceByURL,
  GetLinkStats,
  GetResourceType,
  LinkResources,
  ListExternalResources,
  ListLinks,
  ListRecentResources,
  ListResourceTypes,
  RefreshExternalResource,
  ResolveURNs,
  SearchResources,
  UnlinkResources,
  UpdateResourceLink,
};
